jQuery(document).ready(function ($) {
	// Loop through each post in the elementor posts container
	$(".elementor-posts-container .elementor-post").each(function () {
		// Find the meta data element within this post
		var metaData = $(this).find(".elementor-post__meta-data");

		// Find the title element within this post
		var titleElement = $(this).find(".elementor-post__title");

		// Move the meta data element before the title element
		metaData.insertAfter(titleElement);
	});
	function mobileOnlySlider() {
		$(".elementor-posts-container").slick({
			autoplay: true,
			speed: 1000,
			autoplaySpeed: 5000,
			arrows: false,
			dot: false,
			slidesToShow: 2,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	}
	if (window.innerWidth < 1199) {
		mobileOnlySlider();
	}
	$(window).resize(function (e) {
		if (window.innerWidth < 1199) {
			if (
				!$(".elementor-posts-container").hasClass("slick-initialized")
			) {
				mobileOnlySlider();
			}
		} else {
			if ($(".elementor-posts-container").hasClass("slick-initialized")) {
				$(".elementor-posts-container").slick("unslick");
			}
		}
	});
});
